export interface MetricTooltipData {
  title: string;
  content: string;
}

const defaultMetricTooltips: Record<string, MetricTooltipData> = {
  "Syntax (STX)": {
    title: "Syntax Correctness",
    content: "pass@1 with N=5 for RTL that compiles before functional or synthesis checks"
  },
  "Functionality (EQV)": {
    title: "Formal Equivalence",
    content: "pass@1 with N=5 for Yosys-proven equivalence to golden RTL"
  },
  "Functionality (FNC)": {
    title: "Functional Correctness",
    content: "pass@1 with N=5 for designs that pass the simulator testbench"
  },
  "Synthesis (SYN)": {
    title: "Synthesizability",
    content: "pass@1 with N=5 for correct RTL that synthesizes to gates"
  },
  "Cov Mean": {
    title: "Partition Coverage",
    content: "avg golden RTL partitions reproduced correctly"
  },
  "Cov Median": {
    title: "Median Partition Coverage",
    content: "median golden RTL partitions reproduced correctly"
  },
  "Power": {
    title: "Power",
    content: "PPA-score for power vs the human reference; higher is better"
  },
  "Performance": {
    title: "Performance",
    content: "PPA-score for timing delay vs the human reference; higher is better"
  },
  "Area": {
    title: "Area",
    content: "PPA-score for area vs the human reference; higher is better"
  },
  "EM": {
    title: "Exact Matching",
    content: "% exact next-line matches against the RTL-Repo ground truth"
  },
  "Aggregated Score": {
    title: "Aggregated Score",
    content: "size-weighted PPA-score across selected task benchmarks"
  }
};

const taskMetricTooltips: Record<string, Record<string, MetricTooltipData>> = {
  "Module Completion": {
    "Syntax (STX)": {
      title: "Syntax Correctness",
      content: "pass@1 with N=5 for NotSoTiny modules that compile with Icarus Verilog"
    },
    "Functionality (EQV)": {
      title: "Formal Equivalence",
      content: "pass@1 with N=5 for Yosys-proven equivalence to golden RTL"
    },
    "Cov Mean": {
      title: "Partition Coverage",
      content: "avg golden RTL partitions reproduced correctly across NotSoTiny"
    },
    "Cov Median": {
      title: "Median Partition Coverage",
      content: "median golden RTL partitions reproduced correctly across NotSoTiny"
    }
  },
  "Line Completion": {
    "EM": {
      title: "Exact Matching",
      content: "% predicted RTL lines matching the repository ground truth"
    }
  }
};

export function getMetricTooltip(metricKey: string, task: string): MetricTooltipData {
  if (taskMetricTooltips[task]?.[metricKey]) {
    return taskMetricTooltips[task][metricKey];
  }

  if (defaultMetricTooltips[metricKey]) {
    return defaultMetricTooltips[metricKey];
  }

  return {
    title: metricKey,
    content: `${metricKey} score for the selected benchmark`
  };
}
